import { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router';
import { navigateTo, selectRoute } from 'features/routing/navigationSlice';
import { useAppUrlListener } from 'features/routing/useAppUrlListener';
import { useAppDispatch, useAppSelector } from 'features/store/hooks';

export const NavigationProvider = () => {
  const navigate = useNavigate();
  const route = useAppSelector(selectRoute);
  const dispatch = useAppDispatch();
  useAppUrlListener();

  useEffect(() => {
    if (route) {
      void navigate(route);
      dispatch(navigateTo(null));
    }
  }, [dispatch, navigate, route]);

  return <Outlet />;
};
